import { CaregiverLoginAttemptNotificationLogDto, CaregiverLoginAttemptResult, DeviceTypeEnum } from "@/openapi";
import { NotificationTitle } from "./common";
import { useTranslation } from "react-i18next";

interface Props {
  notification: CaregiverLoginAttemptNotificationLogDto;
}

export const CaregiverLoginAttempt = ({ notification }: Props) => {
  const { t } = useTranslation("notifications");
  const { childName, deviceType, result } = notification.notificationObjectMetadata.props;
  const isSuccess = result === CaregiverLoginAttemptResult.Success;

  return (
    <NotificationTitle clamp={false}>
      {isSuccess ? t("caregiverPasswordUsedOn") : t("wrongCaregiverPasswordEnteredOn")}{" "}
      <b>{deviceType === DeviceTypeEnum.Watch ? t("childWatch", { childName }) : t("childPhone", { childName })}</b>
    </NotificationTitle>
  );
};
